import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import {
  Card,
  Col,
  Container,
  Form,
  Tooltip,
  OverlayTrigger,
  Row,
  Form as Bform,
} from "react-bootstrap";
import Common, { commonData } from "./../../Common";
import { connect } from "react-redux";
import action from "../../Actions";
import Header from "./../../Header";
import NewCustomFilter from "../CustomFilter/CustomFilter";
import ReactSelect from "react-select";
import Pagination from "react-bootstrap/Pagination";
import { Loading, Search } from "../UI";
import AgGridReportComponent from "../AgGridReportComponent";
import ReportFilter from "./ReportFilter";
//import Pagination from "react-js-pagination";
//  const currentDate = new Date();
//  const currentYear = currentDate.getFullYear();
//  const month = currentDate.toLocaleString('default', { month: 'short' });
//  const release_arr = {
//  'Jan' : 2, 'Feb' : 2 ,
//  'Mar' : 4, 'Apr' : 4 ,
//  'May' : 6, 'Jun' : 6 ,
//  'Jul' : 8, 'Aug' : 8 ,
//  'Sept' : 10, 'Oct' : 10,
//  'Nov' : 12, 'Dec' : 12
//  };
//  const currentMonth = release_arr[month];
//  const currentRelease = currentMonth+""+currentYear;
class Backlogs extends Common {
  constructor(props) {
    super(props);
    var app_token = this.getFromStorage("app_token");
    this.boarddata = this.props.getBoardDetailsActions(
      this.props.match.params.attribute_set_key,
      this.getCommonData().user_uuid
    );
    this.state = {
      redirect: false,
      apiUrl: this.decryptconfigdata("apiUrl"),
      app_token: app_token,
      pod_list: {},
      commondata: {},
      //            advance_filter:[{field_name:'release',field_value:"092024",comparison:"greater_than"}]
      advance_filter: [],
      report_data: [],
      isLoading: false,
      pod_options: [],
      columndDef: [],
      filters: [],
      filterVal: {},
      rowDef: [],
      currentPage: 1,
      itemsPerPage: 10,
      sortConfig: {
        key: "",
        direction: "ascending",
      },
    };
  }
  getBacklogColumns = async (filter = null) => {
    console.log(filter, this.props, 372462837);
    let request = {
      app_token: this.state.app_token,
      attribute_set_key: this.props.match.params.attribute_set_key,
      report: this.props.match.params.backlog,
    };

    if (
      filter &&
      Object.values(filter).some(
        (item) => item !== "" && item !== null && item !== undefined
      )
    ) {
      const newObj = Object.entries(filter).reduce(
        (acc, [key, { label, value }]) => {
          acc[key] = value;
          return acc;
        },
        {}
      );
      request = {
        ...request,
        filter: {
          ...newObj,
        },
      };
    }
    const resp = await fetch(`${this.state.apiUrl}reports/data`, {
      method: "POST",
      body: JSON.stringify(request),
    });

    const rdata = await resp.json();
    console.log(rdata, 24534543544564);
    if (rdata.code === 200) {
      this.setState((state) => {
        return {
          ...state,
          columndDef: rdata?.data?.columns || [],
          rowDef: rdata?.data?.rows || [],
          filters: rdata?.data?.filters || [],
          board_title: rdata?.data?.name,
        };
      });
    }
  };

  componentDidMount() {
    //        console.log("env_data",process.env.REACT_APP_INTRANET_API_URL)
    const data = this.getCommonData();
    this.setState({
      ...this.state,
      commondata: data,
    });
    let getboarddata;

    setTimeout(async () => {
      getboarddata = await this.boarddata.then((res) => {
        return res.data?.[0];
      });
      this.setState(
        {
          ...this.state,
          boarddata: getboarddata,
        },
        () => {}
      );
    }, 200);
    this.getBacklogColumns();
    document.title = `${this.props.match.params.attribute_set_key.toUpperCase()} | Report`;
  }
  // Handler for changing the page
  handlePageChange = (pageNumber) => {
    this.setState({
      currentPage: pageNumber,
    });
  };

  getQueryParams = (podId = null, cate = null, type = null) => {
    let conststring = { release: [111111] };

    if (podId) {
      conststring = {
        ...conststring,
        pod_department: [podId],
      };
    }
    if (cate) {
      conststring = {
        ...conststring,
        category: [cate],
      };
    }

    if (type) {
      conststring = {
        ...conststring,
        type: type,
      };
    }
    const filterval = JSON.stringify({ ...conststring });

    const queryParams = {
      q: filterval, // This is already a JSON string
    };

    const queryString = Object.keys(queryParams)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`
      )
      .join("&");

    return `?${queryString}`;
  };

  getBodyData = (currentData) => {
    if (!this.state.sortConfig.key) {
      currentData = currentData
        .map((item) => ({
          ...item,
          pod_id: item.pod_id,
          value: this.state.pod_list[item.pod_id] || "chec",
        }))
        .sort((a, b) => a.value.localeCompare(b.value));
    }
    if (this.state.isLoading) {
      return (
        <tr>
          <td colSpan={100}>
            <Loading />
          </td>
        </tr>
      );
    }
    if (currentData.length === 0) {
      return (
        <tr>
          <td colspan="8" class="no-data">
            No data found.
          </td>
        </tr>
      );
    }
    return currentData.map((item, index) => {
      return (
        <tr>
          <td>
            <a
              class="backlog-a"
              onClick={() =>
                this.setFilterRows("pod_department", item.pod_id, 0, index)
              }
            >
              {this.state.pod_list && this.state.pod_list[item.pod_id]}
            </a>
          </td>
          <td>
            <Link
              class="backlog-a"
              to={{
                pathname: `/tattle/er/list`,
                search: this.getQueryParams(
                  item.pod_id,
                  null,
                  item.type_customer.value
                ),
              }}
            >
              {item.type_customer.cnt}
            </Link>
          </td>
          <td>
            <Link
              class="backlog-a"
              to={{
                pathname: `/tattle/er/list`,
                search: this.getQueryParams(
                  item.pod_id,
                  null,
                  item.type_internal.value
                ),
              }}
            >
              {item.type_internal.cnt}
            </Link>
          </td>
          <td>
            <Link
              class="backlog-a"
              to={{
                pathname: `/tattle/er/list`,
                search: this.getQueryParams(
                  item.pod_id,
                  "639c000fa480b31126095136"
                ),
              }}
            >
              {item.category_feature.cnt}
            </Link>
          </td>
          <td>
            <Link
              class="backlog-a"
              to={{
                pathname: `/tattle/er/list`,
                search: this.getQueryParams(
                  item.pod_id,
                  "639c000fa480b31126095135"
                ),
              }}
            >
              {item.category_bug.cnt}
            </Link>
          </td>
          <td>
            <a
              class="backlog-a"
              to={{
                pathname: `/tattle/er/list`,
                search: this.getQueryParams(
                  item.pod_id,
                  "639c000fa480b31126095138"
                ),
              }}
            >
              {item.category_tech.cnt}
            </a>
          </td>
          <td>{item.total}</td>
          {/* <td>{item.total_hrs}</td> */}
        </tr>
      );
    });
  };

  setFilterRows = (item_name, pod_info, key, rowIndex, item_info) => {
    var add_obj = {};
    var pod_obj = {};
    var default_arr = [];
    default_arr = {
      release: [111111],
      pod_department: [pod_info],
      group_by: "priority",
    };
    // {
    //   field_name: "status",
    //   field_value: ["639c000fa480b31126095143"],
    //   comparison: "not_equals",
    // },

    var filter_val = [];
    if (item_info) {
      add_obj["field_name"] = item_name;
      add_obj["field_value"] = [item_info];
      add_obj["comparison"] = "equals";

      pod_obj["field_name"] = "pod_department";
      pod_obj["field_value"] = [pod_info];
      pod_obj["comparison"] = "equals";
      filter_val.push(pod_obj);
    } else {
      add_obj["field_name"] = item_name;
      add_obj["field_value"] = [pod_info];
      add_obj["comparison"] = "equals";
    }
    filter_val.push(add_obj);
    let final_filter_val = default_arr;

    let newfilter = JSON.stringify(final_filter_val);
    let filterTosearch = {};
    filterTosearch = {
      ...filterTosearch,
      [this.props.match.params.attribute_set_key]: newfilter,
    };
    if (filterTosearch) {
      let queryString = Object.values(filterTosearch)
        .map((obj) => new URLSearchParams(obj).toString())
        .join("&");
      if (queryString.endsWith("=")) {
        queryString = queryString.slice(0, -1);
      }
      this.props.history.push(
        "/tattle/er/kanban?type=backlog&q=" + queryString
      );
    }
  };

  createFilter = (filterType) => {
    this.props.history.push("/tattle/er/list", {
      page: "backlogs",
      filterType: filterType,
    });
  };

  handleChange(e) {
    var selected_pod = e;
    if (selected_pod && selected_pod.length > 0) {
      //            let filter_pod = Object.values(this.state.report_data_original).filter(it => it.pod_id == selected_pod);
      let filteredArray = Object.values(this.state.report_data_original).filter(
        (item) => selected_pod.map((x) => x.value).includes(item.pod_id)
      );
      this.setState({ report_data: filteredArray });
    } else {
      this.setState({ report_data: this.state.report_data_original });
    }
    this.setState({ selected_pod });
  }

  getNestedValue = (obj, keyPath) => {
    return keyPath
      .split(".")
      .reduce((acc, key) => (acc ? acc[key] : undefined), obj);
  };

  getSortedData = () => {
    const { report_data } = this.state;
    const { sortConfig } = this.state;
    const sortedData = [...report_data];

    if (sortConfig.key) {
      sortedData.sort((a, b) => {
        const aValue = this.getNestedValue(a, sortConfig.key);
        const bValue = this.getNestedValue(b, sortConfig.key);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortedData;
  };

  getTodalDisplayCount = (totalCount) => {
    this.setState((state) => {
      return {
        ...state,
        totalRowCount: totalCount,
      };
    });
  };

  requestSort = (key) => {
    this.setState((prevState) => {
      let direction = "ascending";

      if (
        prevState.sortConfig.key === key &&
        prevState.sortConfig.direction === "ascending"
      ) {
        direction = "descending";
      }

      return {
        sortConfig: { key, direction },
      };
    });
  };
  filterChangeHandler = (e, name) => {
    if (e) {
      this.setState(
        (state) => {
          return {
            ...state,
            filterVal: {
              ...state.filterVal,
              [name]: e,
            },
          };
        },
        () => {
          this.getBacklogColumns(this.state.filterVal);
        }
      );
    } else {
      this.setState(
        (state) => {
          return {
            ...state,
            filterVal: {
              ...state.filterVal,
              [name]: "",
            },
          };
        },
        () => {
          this.getBacklogColumns(this.state.filterVal);
        }
      );
    }
  };
  render() {
    let currentData;
    const itemsPerPage = this.state.itemsPerPage;
    const totalPages = Math.ceil(
      this.state.report_data && this.state.report_data.length / itemsPerPage
    );

    // Get the items for the current page
    const startIndex = (this.state.currentPage - 1) * itemsPerPage;
    currentData = this.getSortedData();
    currentData =
      currentData && currentData.slice(startIndex, startIndex + itemsPerPage);

    //        console.log(107,currentData);

    let headername;

    if (this.props.match.params) {
      const { backlog, attribute_set_key } = this.props.match.params;

      const reports = this.state.boarddata?.filter?.reports ?? [];

      headername = (reports || []).find(
        (it) =>
          it?.attribute_set_key === attribute_set_key && it?.report === backlog
      );
    }

    return (
      <div class="mainContent-panel-wrap" style={{ overflow: "auto" }}>
        <Header
          brecum_name={{
            name: "Reports",
            link: `/tattle/${this.props.match.params.attribute_set_key}/list`,
          }}
          brecum_page={this.props.match.params.attribute_set_key.toUpperCase()}
          pageName="ER"
        />
        <div className="main_custom_class">
          <NewCustomFilter
            filters={this.state.boarddata && this.state.boarddata.filter}
            isView={true}
            isAdmin={this.state.commondata.is_admin == 1 ? 1 : 0}
            enebleClickFilter={() => this.createFilter(0)}
            enebleAdvancedClickFilter={() => this.createFilter(1)}
            attribute_set_type={
              this.state.boarddata && this.state.boarddata.attribute_set_type
            }
            board_title={this.state.board_title}
            className="listingpagefilter"
          />
          <Container fluid className="g-0 fullHeight">
            <div
              className="page-content pt-1 new-content-main"
              style={!this.props.toggleMenu ? { marginLeft: 180 } : {}}
            >
              <div className="parentcrdclass card-body" style={{padding:"1rem"}}>
                <div className="justify-content-end align-items-center gx-2 row">
                  <div class="col parent-title">
                    <div class="board-parent__division">
                      <Link
                        class="txt-dark underline-none"
                        to={`/tattle/${this.props.match.params.attribute_set_key}/list`}
                      >
                        <span class="new_back">
                          <svg
                            width="14"
                            height="12"
                            viewBox="0 0 14 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.0026 5.33333H3.27856L6.80723 1.80467L5.86456 0.862L0.726562 6L5.86456 11.138L6.80723 10.1953L3.27856 6.66667H13.0026V5.33333Z"
                              fill="#5C5F62"
                            ></path>
                          </svg>
                        </span>
                        &nbsp;
                      </Link>
                      {console.log(headername, 23343454354)}
                      <span class="inline-edit-board">
                        {this.props.location?.state?.title ||
                          this?.state?.board_title}{" "}
                        ({this.state.totalRowCount})
                      </span>
                    </div>
                    <div className="report-filter">
                      <ReportFilter
                        filters={this.state.filters}
                        filterChangeHandler={this.filterChangeHandler}
                        filterVal={this.state.filterVal}
                      />
                    </div>
                  </div>
                </div>
                <div className="ag-theme-alpine mt-3 backlog">
                  {/* <AgGridReact
                    columnDefs={this.state.columndDef}
                    rowData={this.state.rowDef}
                  /> */}
                  <AgGridReportComponent
                    rows={this.state.rowDef}
                    columns={this.state.columndDef}
                    getTodalDisplayCount={this.getTodalDisplayCount}
                  />
                </div>
                {/* <div style={{ marginTop: "20px" }}>
                  <Pagination className="backlog-pagination">
                    <Pagination.First
                      onClick={() => this.handlePageChange(1)}
                    />
                    {Array.from({ length: totalPages }, (_, index) => (
                      <Pagination.Item
                        key={index}
                        active={this.state.currentPage === index + 1}
                        onClick={() => this.handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Last
                      onClick={() => this.handlePageChange(totalPages)}
                    />
                  </Pagination>
                </div> */}
              </div>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    boardData: state.boardAttribute.filter,
    toggleMenu: state.boardAttribute.toggleMenu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBoardDetailsActions: (input) => {
      return dispatch(action.getBoardDetailsAction(input));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Backlogs);
